// extracted by mini-css-extract-plugin
export default {"profile":"c8sIF","profileLabel":"cvA_h","buttons":"GFL9I","statementMultiple":"Uoaqn"};